module.exports = __webpack_public_path__ + "img/mascot.ae284a40.png";